import React from 'react';

interface WalletIconProps {
  size?: number;
}

const WalletIcon: React.FC<WalletIconProps> = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="wallet">
        <path
          id="Vector"
          d="M19 20H5C3.89543 20 3 19.1046 3 18V9C3 7.89543 3.89543 7 5 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20Z"
          stroke="currentColor"
          strokeOpacity="0.9"
          strokeWidth="1.5"
        />
        <path
          id="Vector_2"
          d="M16.5 14C16.2239 14 16 13.7761 16 13.5C16 13.2239 16.2239 13 16.5 13C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14Z"
          fill="currentColor"
          fillOpacity="0.9"
          stroke="currentColor"
          strokeOpacity="0.9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M18 7V5.60322C18 4.28916 16.7544 3.33217 15.4847 3.67075L4.48467 6.60409C3.60917 6.83756 3 7.63046 3 8.53656V9"
          stroke="currentColor"
          strokeOpacity="0.9"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export default WalletIcon;
